import { AssetsListAPIQueryParams, assetsAssetV2List, Asset, PaginatedAssetListList } from '@goldcast/api/content';
import { IStringifyOptions } from 'qs';
import { IconName } from '@/components/atoms/Icon';

export type MenuItemsLabelType =
  | 'Download'
  | 'Rename'
  | 'Delete'
  | 'Edit'
  | 'Generate Social Post'
  | 'Duplicate'
  | 'Create Clip'
  | 'Rename Chapter'
  | 'Remove Chapter';

//TODO: use actual type i.e. TypeEnum
export const menuItems: Record<
  'CLIP' | 'TEXT' | 'CHAPTER',
  { label: MenuItemsLabelType; iconName: IconName; clipListOnly?: boolean }[]
> = {
  CLIP: [
    {
      label: 'Edit',
      iconName: 'IconEdit'
    },
    {
      label: 'Rename',
      iconName: 'IconPencil'
    },
    {
      label: 'Download',
      iconName: 'IconDownload'
    },
    {
      label: 'Generate Social Post',
      iconName: 'IconSparkles'
    },
    {
      label: 'Duplicate',
      iconName: 'IconCopy'
    },
    {
      label: 'Delete',
      iconName: 'IconTrash'
    }
  ],
  TEXT: [
    {
      label: 'Download',
      iconName: 'IconDownload'
    },
    {
      label: 'Delete',
      iconName: 'IconTrash'
    }
  ],
  CHAPTER: [
    {
      label: 'Rename Chapter',
      iconName: 'IconPencil'
    },
    {
      label: 'Create Clip',
      iconName: 'IconScissors'
    },
    {
      label: 'Remove Chapter',
      iconName: 'IconBookmarkMinus'
    }
  ]
};

export function parseArrayQueryParam(queryParam: string | string[] | undefined): string[] {
  if (queryParam === undefined) {
    return [];
  }

  if (typeof queryParam === 'string') {
    return [queryParam];
  }

  return queryParam;
}

export const ASSET_TABLE_PAGE_LIMIT = 30;

type NonNullableAssetsListAPIQueryParams = {
  [K in keyof AssetsListAPIQueryParams]: NonNullable<Required<AssetsListAPIQueryParams>[K]>;
};

export type AssetsTableQueryParams = Pick<
  NonNullableAssetsListAPIQueryParams,
  'offset' | 'events' | 'broadcasts' | 'types' | 'search'
> & {
  sort_by?: keyof Pick<Asset, 'created_at' | 'title'>;
  desc?: boolean;
};

export const defaultQueryParams: AssetsTableQueryParams = {
  offset: 0,
  sort_by: 'created_at',
  desc: true
};

export function loadAssets(
  restQueryParams: AssetsTableQueryParams,
  ordering: string | undefined,
  offset: number | undefined
): Promise<PaginatedAssetListList> {
  return assetsAssetV2List({
    queryParams: {
      limit: ASSET_TABLE_PAGE_LIMIT,
      ordering,
      ...(offset !== undefined && { offset: offset * ASSET_TABLE_PAGE_LIMIT }),
      search: restQueryParams.search,
      types: restQueryParams.types,
      projects: restQueryParams.events,
      contents: restQueryParams.broadcasts
    },
    queryParamsStringifyOptions: {
      arrayFormat: 'comma'
    } as IStringifyOptions
  }).catch(err => Promise.reject(err));
}
